import { Component } from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {ApiProvider} from "../../providers/api/api";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {InitHelloPage} from "../init-hello/init-hello";
import {IntroNamePage} from "../intro-name/intro-name";

/**
 * Generated class for the InitPrescriptionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-init-prescription',
  templateUrl: 'init-prescription.html',
})
export class InitPrescriptionPage {

  selectedValue = 1;
  step: number = 1;
  code: string = '';
  errorVisible: boolean = false;
  translationPrefix: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private contentTranslation: ContentTranslationProvider,
    private loaderCtrl: LoadingController,
    private api: ApiProvider,
    private userState: UserStateProvider
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InitPrescriptionPage');
  }

  updateResponse(value: number) {
    this.selectedValue = value;
    this.nextPage();
  }

  showInfoPopup() {
    var alert = this.alertCtrl.create({
      title: null,
      subTitle: this.contentTranslation.translateContent('Modal prescription Problem Text'),
      buttons: [
        {
          text: this.contentTranslation.translateContent('OK').toUpperCase(),
        },
        {
          text: '×',
          cssClass: 'close-button'
        }],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();
  }

  nextPage() {
    if (this.step == 1) {
      if (!this.selectedValue) {
        var alert = this.alertCtrl.create({
          title: this.contentTranslation.translateContent('Modal prescription Required Title'),
          subTitle: this.contentTranslation.translateContent('Modal prescription Required Text'),
          buttons: [
            {
              text: this.contentTranslation.translateContent('OK').toUpperCase(),
            },
            {
              text: '×',
              cssClass: 'close-button'
            }],
          cssClass: 'ip-alert ip-with-close meillitus-popup'
        });
        alert.present();
      } else {
        this.step++;
      }
    }
  }

  saveData(validate: boolean) {
    if (validate && !this.code) {
      this.errorVisible = true;
      return;
    }
    this.errorVisible = false;

    let loader = this.loaderCtrl.create();
    loader.present();

    this.api.callPost('/users/'+this.userState.user.id+'/validatePartnerCode', {code: this.code}).subscribe((res: any) => {
      console.log(res);
      if(!res.status) {
        throw new Error("Status is false");
      }

      loader.dismissAll();
      this.navCtrl.push(IntroNamePage);
    }, (res:any) => {

      if(res.error && !res.error.status && res.error.bgmUsed) {
        var alert = this.alertCtrl.create({
          title: this.contentTranslation.translateContent('Modal partner code Used Title'),
          subTitle: this.contentTranslation.translateContent('Modal partner code Used Text'),
          buttons: [
            {
              text: this.contentTranslation.translateContent('OK').toUpperCase(),
            }],
          cssClass: 'password-forgotten-modal'
        });
        alert.present();
        loader.dismissAll();
        return ;
      } else {
        var alert = this.alertCtrl.create({
          title: this.contentTranslation.translateContent(this.translationPrefix + 'Modal partner code Problem Title'),
          subTitle: this.contentTranslation.translateContent(this.translationPrefix + 'Modal partner code Problem Text'),
          buttons: [
            {
              text: this.contentTranslation.translateContent('OK').toUpperCase(),
            }],
          cssClass: 'password-forgotten-modal'
        });
        alert.present();
        loader.dismissAll();
      }
    });

    /*this.api.callPut('/users/' + this.userState.user.id, {prescriptionCode: this.code}).subscribe((res: any) => {
      loader.dismissAll();
      this.navCtrl.push(IntroNamePage);
    }, () => {
      loader.dismissAll();
      this.errorVisible = true;
    })*/

  }
  checkForEnter(e: KeyboardEvent) {
    this.errorVisible = false;
    console.log(e);
    if(e && e.keyCode === 13) {
      this.saveData(true);
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/init-prescription/init-prescription.ts